module.exports = __webpack_public_path__ + "static/media/the_crossing_at_sunset_small.ff4dfa56.jpg";